import { AD_PLATFORM_TO_AD_TYPENAMES_MAP } from 'components/Ads/utils/constants';
import { AdTypename } from 'components/Ads/utils/types';

const META_AD_TYPENAMES = new Set<AdTypename>(AD_PLATFORM_TO_AD_TYPENAMES_MAP.meta);

export interface MetaCampaignAdCheck {
  __typename: string;
  facebookPage?: { id: string } | null;
}

export function isMetaOnlyCampaign(ads: MetaCampaignAdCheck[]): boolean {
  if (!ads.length) {
    return false;
  }

  // TODO: instead of checking every ad, check if the campaign has any ad that is not meta
  return ads.every((ad) => META_AD_TYPENAMES.has(ad.__typename as AdTypename));
}

export function hasMetaAdWithoutFacebookPage(ads: MetaCampaignAdCheck[]): boolean {
  return ads.some((ad) => META_AD_TYPENAMES.has(ad.__typename as AdTypename) && !ad.facebookPage?.id);
}

export function shouldBlockLaunchForMissingFacebookPage(ads: MetaCampaignAdCheck[]): boolean {
  return isMetaOnlyCampaign(ads) && hasMetaAdWithoutFacebookPage(ads);
}
